import { toast } from "react-toastify";

// Centralized API response handler
export const handleAPIResponse = async (response) => {
  if (response.status === 401) {
    localStorage.removeItem("token");
    toast.error("Session expired! Please login again.");
    setTimeout(() => {
      window.location.href = "/login";
    }, 2500); 
    return { success: false, message: "Session expired" };
  }
  if (!response.ok) {
    let errorMessage = "Something went wrong. Please try again.";
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorMessage;
      toast.error(errorMessage);
      console.error("API Error:", errorMessage);
    } catch {
     console.error("Failure!")
    }
    return { success: false, message: errorMessage };
  }
  return { success: true, data: await response.json() };
};

// Wrapper for API calls that handles 401 responses
export const apiCall = async (url, options = {}) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(url, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
        ...options.headers,
      },
    });

    return await handleAPIResponse(response);
  } catch (error) {
    console.error("API call failed:", error);
    return {
      success: false,
      message: "Network error. Please check your connection and try again.",
    };
  }
};
